import { render, staticRenderFns } from "./NotLoggedInCard.vue?vue&type=template&id=5c71133c&scoped=true&"
import script from "./NotLoggedInCard.vue?vue&type=script&lang=js&"
export * from "./NotLoggedInCard.vue?vue&type=script&lang=js&"
import style0 from "./NotLoggedInCard.vue?vue&type=style&index=0&id=5c71133c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71133c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
installComponents(component, {VBanner})
